export default "__VITE_ASSET__BKPuB_xX__"